import request from '@/utils/request'

export function getGroupTourList(data) {
  return request({
    url: '/AppManage/getGroupTourList',
    method: 'post',
    data,
  })
}

export function getRecordRequestList(query) {
  return request({
    url: '/AppManage/getRecordRequestList',
    method: 'get',
    params: query,
  })
}

export function getDataReference(data) {
  return request({
    url: '/AppManage/getDataReference',
    method: 'post',
    data,
  })
}

export function modifyRecordRequestStatus(data) {
  return request({
    url: '/AppManage/modifyRecordRequestStatus',
    method: 'post',
    data,
  })
}

export function getRecordRequestLog(query) {
  return request({
    url: '/AppManage/getRecordRequestLog',
    method: 'get',
    params: query,
  })
}

export function getRecordRequestApplyDoneData(query) {
  return request({
    url: '/AppManage/getRecordRequestApplyDoneData',
    method: 'get',
    params: query,
  })
}

//旅行社提交故障與回饋表單
export function saveFaultBack(data) {
  return request({
    url: '/AppManage/saveFaultBack',
    method: 'post',
    data,
  })
}
//後臺取得資料
export function getFaultBack(query) {
  return request({
    url: '/AppManage/getFaultBack',
    method: 'get',
    params: query,
  })
}
//後臺刪除資料
export function deleteFaultBack(data) {
  return request({
    url: '/AppManage/deleteFaultBack',
    method: 'post',
    data,
  })
}
//取得未解決的故障與回報
export function getNotSolveFaultBack() {
  return request({
    url: '/AppManage/getNotSolveFaultBack',
    method: 'get',
  })
}
//更新解決
export function saveSolvedFaultBack(id) {
  return request({
    url: '/AppManage/saveSolvedFaultBack/' + id,
    method: 'get',
  })
}
